<template>
  <div>
    <el-menu
      v-if="isPc"
      :default-active="activeIndex"
      class="el-menu-vertical-demo"
      background-color="#F4F4F4"
      text-color="#20317f"
      active-text-color="#ffffff"
      router
      @open="handleOpen"
      @close="handleClose">
      <el-menu-item :index="index+''" :route="`${item.url}`" v-for="(item, index) in menuList " :key=item.name>
        <!-- <i :class="item.icon"></i> -->
        <span slot="title">{{item.name}}</span>
      </el-menu-item>
    </el-menu>
    <el-menu
      v-else
      mode="horizontal"
      :default-active="activeIndex"
      class="m-left-nav"
      text-color="#333"
      active-text-color="#fff"
      router
      >
      <el-menu-item :index="index+''" :route="`${item.url}`" v-for="(item, index) in menuList " :key=item.name>
        <i :class="item.icon"></i>
        <span slot="title">{{item.name}}</span>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data(){
    return {
      activeIndex:'0',
      menuList:[
        {
          name:'個人信息',
          icon:'el-icon-setting',
          url:'/person_center'
        },
        {
          name:'我的企業',
          icon:'el-icon-office-building',
          url:'/my_company'
        },
        {
          name:'消息中心',
          icon:'el-icon-chat-line-square',
          url:'/my_message'
        },
        {
          name:'我的收藏',
          icon:'el-icon-star-off',
          url:'/my_collection'
        },
        {
          name:'我的需求',
          url:'/my_need'
        },
        {
          name:'會員權益',
          icon:'el-icon-collection',
          url:'/my_rights'
        },
        // {
        //   name:'我的活動',
        //   icon:'el-icon-bell',
        //   url:'/my_activity'
        // },
        // {
        //   name:'我的問卷',
        //   icon:'el-icon-tickets',
        //   url:'/my_questionnaire'
        // },
        // {
        //   name:'繳費情況',
        //   icon:'el-icon-goods',
        //   url:'/my_fee'
        // },
        // {
        //   name:'修改密碼',
        //   icon:'el-icon-lock',
          // url:'/person_center'
        // },
        {
          name:'隱私政策',
          icon:'el-icon-help',
          url:'/privacy'
        },
        {
          name:'用戶協議',
          icon:'el-icon-warning-outline',
          url:'/user_agreement'
        }
      ]
    }
  },
  computed: {
    ...mapState(["rowMenuList","isPc"]),
  },
  methods: {
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    }
  },
  watch:{
    $route(to,from){
      // console.log('to=====',to);
      this.menuList.map((item,index) => {
        if (item.url==this.$route.path){
          this.activeIndex=index+''
        }
      })
    }
  },
  mounted(){
    //更换路由菜单对应变化
    this.menuList.map((item,index) => {
      if (item.url==this.$route.path){
        this.activeIndex=index+''
      }
    })
  }
}
</script>

<style lang="less" scoped>

.el-menu-vertical-demo{
  width: 140px;
  border-radius: 4px;
  overflow: hidden;
  .el-menu-item{
    font-size: 18px;
    text-align: center;
    padding: 0!important;
  }
  .el-menu-item.is-active{
    background: #20317f!important;
  }
  .el-menu-item:hover{
    background: #20317f!important;
    color: #fff!important;
    i{
      color: #fff!important;
    }
  }
}
.m-left-nav{
  // padding: 0 20px;
  margin: 10px 0;
}
</style>